exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-message-custom-content{display:flex}.ant-message-notice-content{width:100%;background-color:#dbefda}.ant-message-notice-content .ant-message-custom-content{justify-content:center;position:relative}.ant-message-notice-content .ant-message-custom-content .cap-icon-v2-close{position:absolute;right:0}\n", ""]);

// exports
